import Vue from 'vue';
import Router from 'vue-router';
import Principal from '@/components/Main.vue';
import { storeInstance } from '@/store';

Vue.use(Router);

let routesArray = [
  {
    path: '/',
    redirect: '/Crear',
    name: 'home',
    component: Principal,
    props: { pageSize: 25 },
    children: [
      {
        path: '/Crear',
        meta: {
          title: 'TSZ - Crear presupuesto'
        },
        name: 'Crear',
        component: () =>
          import('@/components/Presupuestos/views/TSZ_Presupuestos.vue')
      }
    ]
  }
];

if (process.env.VUE_APP_ACCESO_ADMIN == 1) {
  routesArray = [
    {
      path: '/',
      redirect: '/Crear',
      name: 'home',
      component: Principal,
      props: { pageSize: 25 },
      children: [
        {
          path: '/Crear',
          meta: {
            title: 'TSZ - Crear presupuesto'
          },
          name: 'Crear',
          component: () =>
            import('@/components/Presupuestos/views/TSZ_Presupuestos.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/Usuarios/views/TSZ_Usuarios.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/Comparativa',
      name: 'home_',
      component: Principal,
      props: { pageSize: 25 },
      children: [
        {
          path: '/Comparativa',
          meta: {
            title: 'TSZ - Comparativa'
          },
          name: 'Comparativa',
          component: () =>
            import('@/components/Comparativa/views/TSZ_Comparativas.vue')
        }
      ]
    },
    {
      path: '/Presupuestos',
      // redirect: '/Presupuestos',
      name: 'presupuestos',
      component: Principal,
      props: { pageSize: 25 },
      children: [
        {
          path: '/Presupuestos',
          meta: {
            title: 'TSZ - Listado de presupuestos'
          },
          name: 'Presupuestos',
          component: () =>
            import('@/components/Listados/views/TSZ_Listados.vue')
        }
      ]
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/components/shared/views/Logout')
    },
    {
      path: '*',
      name: '404',
      component: require('@/404.vue').default
    },
    {
      path: '/UsuarioInterno',
      name: 'usuario_interno',
      component: () =>
        import('@/components/Usuarios/views/TSZ_Usuarios_Internos.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/UsuarioExterno',
      name: 'usuario_externo',
      component: () =>
        import('@/components/Usuarios/views/TSZ_Usuarios_Externos.vue'),
      meta: {
        AllowAnonymous: true
      }
    },

    {
      path: '/Registro',
      name: 'registro',
      component: () =>
        import('@/components/Usuarios/views/TSZ_Usuarios_Tipo.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/Validacion',
      name: 'validacion',
      component: () => import('@/components/Usuarios/views/TSZ_Validacion.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/Recordar',
      name: 'recordar',
      component: () => import('@/components/Usuarios/views/TSZ_Resetear.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/RecordarPassword',
      name: 'recordarcontraseña',
      component: () =>
        import('@/components/Usuarios/views/TSZ_Recordar_Contraseña.vue'),
      meta: {
        AllowAnonymous: true
      }
    },
    {
      path: '/Usuarios',
      // redirect: '/Usuarios',
      name: 'usuarios',
      component: Principal,
      props: { pageSize: 25 },
      children: [
        {
          path: '/Usuarios',
          name: 'Usuarios',
          component: () =>
            import('@/components/Usuarios/views/TSZ_Usuarios.vue')
        }
      ]
    }
  ];
}

const routes = new Router({
  base: process.env.VUE_APP_URL,
  mode: 'history',
  routes: routesArray
});

if (process.env.VUE_APP_ACCESO_ADMIN == 1) {
  routes.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.AllowAnonymous)) {
      if (storeInstance.getters['TSZ/isLoggedIn']) {
        next('/Presupuestos');
      } else {
        next();
      }
    } else {
      if (storeInstance.getters['TSZ/isLoggedIn']) {
        next();
      } else {
        next('/login');
      }
    }
  });
} else {
}

export default routes;
